import { Component, OnDestroy, OnInit, Inject} from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { AuthService } from '../../services/auth/auth.service';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import 'rxjs/add/operator/takeUntil';
import { Data } from '../../models/data';
import { Router } from '@angular/router';


//import { Observable } from 'rxjs';
//import { FileUploadService } from '../../services/file-upload.service';


export interface DialogData {
  animal: string;
  name: string;
}


//states
interface State {
  value: string;
  viewValue: string;
}

//compstates
interface Compstate {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-apply-digitalid',
  templateUrl: './apply-digitalid.page.html',
  styleUrls: ['./apply-digitalid.page.scss'],
})

export class ApplyDigitalidPage implements OnInit, OnDestroy {

  digitalidPrice = 1;
  myresponse: any;
  verify = false;


  open(menu)
  {
    menu.openMenu();
  }
  
  current_year: number = new Date().getFullYear();
  //chk_consent = false;

  //upload file
  /*selectedFiles?: FileList;
  progressInfos: any[] = [];
  message: string[] = [];

  previews: string[] = [];
  imageInfos?: Observable<any>;*/

  //states
  states: State[] = [
    { value: "Johor", viewValue: "JOHOR" },
    { value: "Kedah", viewValue: "KEDAH" },
    { value: "Kelantan", viewValue: "KELANTAN" },
    { value: "Melaka", viewValue: "MELAKA" },
    { value: "Negeri Sembilan", viewValue: "NEGERI SEMBILAN" },
    { value: "Pahang", viewValue: "PAHANG" },
    { value: "Perak", viewValue: "PERAK" },
    { value: "Perlis", viewValue: "PERLIS" },
    { value: "Pulau Pinang", viewValue: "PULAU PINANG" },
    { value: "Sabah", viewValue: "SABAH" },
    { value: "Sarawak", viewValue: "SARAWAK" },
    { value: "Selangor", viewValue: "SELANGOR" },
    { value: "Terengganu", viewValue: "TERENGGANU" },
    { value: "WP Kuala Lumpur", viewValue: "WP KUALA LUMPUR" },
    { value: "WP Labuan", viewValue: "WP LABUAN" },
    { value: "WP Putrajaya", viewValue: "WP PUTRAJAYA" },
  ];
  //end states

  //Compstates
  compstates: Compstate[] = [
    { value: "Johor", viewValue: "JOHOR" },
    { value: "Kedah", viewValue: "KEDAH" },
    { value: "Kelantan", viewValue: "KELANTAN" },
    { value: "Melaka", viewValue: "MELAKA" },
    { value: "Negeri Sembilan", viewValue: "NEGERI SEMBILAN" },
    { value: "Pahang", viewValue: "PAHANG" },
    { value: "Perak", viewValue: "PERAK" },
    { value: "Perlis", viewValue: "PERLIS" },
    { value: "Pulau Pinang", viewValue: "PULAU PINANG" },
    { value: "Sabah", viewValue: "SABAH" },
    { value: "Sarawak", viewValue: "SARAWAK" },
    { value: "Selangor", viewValue: "SELANGOR" },
    { value: "Terengganu", viewValue: "TERENGGANU" },
    { value: "WP Kuala Lumpur", viewValue: "WP KUALA LUMPUR" },
    { value: "WP Labuan", viewValue: "WP LABUAN" },
    { value: "WP Putrajaya", viewValue: "WP PUTRAJAYA" },
  ];
  //end Compstate

  isCompleted = false;
  isCompleted2 = false;
  isCompleted3 = false;
  isCompleted4 = false;
  isLinear = true;
  
  is_firstname = false;
  is_lastname = false;
  is_mykad = false;
  is_mobile = false;
  is_address = false;
  is_postcode = false;
  is_city = false;
  is_state = false;
  is_email = false;

  is_company_address = false;
  is_company_postcode = false;
  is_company_city = false;
  is_company_state = false;
  is_company_mobile = false;

  is_compstate = false;

  is_upload_mykad_front = false;
  is_upload_mykad_back = false;
  is_upload_payslip = false;


  msg_firstname = 'First Name is required';
  msg_lastname = 'Last Name is required';
  msg_mykad = 'MyKad No/Passport No is required';
  msg_mobile = 'Mobile is required';
  msg_address = 'Permanent Address is required';
  msg_postcode = 'Postcode is required';
  msg_city = 'City is required';
  msg_state = 'State is required';
  msg_email = 'Email is required';

  msg_company_address = 'Company Address is required';
  msg_company_postcode = 'Company Postcode is required';
  msg_company_city = 'Company City is required';
  msg_company_state = 'Company State is required';
  msg_company_mobile = 'Company Mobile is required';

  msg_upload_mykad_front = 'Upload MyKad (Front) is required';
  msg_upload_mykad_back = 'Upload MyKad (Back) is required';
  msg_upload_payslip = 'Upload PaySlip is required';


  pre_firstname: any;
  pre_lastname: any;
  pre_mykad: any;
  pre_mobile: any;
  pre_address: any;
  pre_postcode: any;
  pre_city: any;
  pre_state: any;
  pre_email: any;

  pre_company_address: any;
  pre_company_postcode: any;
  pre_company_city: any;
  pre_company_state: any;
  pre_company_email: any;
  pre_company_mobile: any;

  pre_upload_mykad_front = '';
  pre_upload_mykad_back = '';
  pre_upload_payslip = '';

  data = new Data();
  createdid_data = new Data();
  applicant_data = new Data();

  constructor(private apiService: ApiService,
    private authService: AuthService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private barcodeScanner: BarcodeScanner,
    private router: Router,
    private navCtrl: NavController,
    public dialog: MatDialog,
    //uploadService: FileUploadService,
    private spinner: NgxSpinnerService) {


  }

  ngOnInit() {
    //this.imageInfos = this.uploadService.getFiles();
  }

  
  openDialog(): void {
    const dialogRef = this.dialog.open(DialogApplyDigitalidPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  

submit()
{
  this.spinner.show();

  const wallet = localStorage.getItem('wallet');
  const test = wallet.replace(',', '');
  const balance = Number.parseFloat(test) - this.digitalidPrice;

  console.log(test + ' ' + balance);

  if (Number.parseFloat(test) >= this.digitalidPrice ) 
  {
      const dt = {
      mobile: this.pre_mykad,
      amount: this.digitalidPrice,
      product: '3225',
      user: localStorage.getItem('user'),
      order: null,
      rrp: this.digitalidPrice
    };

    this.data =  {
      id: 5,
      name: 'addOrder',
      content: dt
    };
    
    this.apiService.pay(this.data).subscribe((response) => {
      this.data.content.order = response;

      this.apiService.wallet(this.data).subscribe((res) => {

        const dt2 = {
          order: this.data.content.order
        };

        this.createdid_data = {
          id: 1,
          name: 'did',
          content: dt2
        };

        console.log(this.createdid_data + this.data.content.order);

        const createdid = {
          user: localStorage.getItem('user'),
          status: 2, //new apply - status pending
          firstName: this.pre_firstname,
          lastName: this.pre_lastname,
          mykad: this.pre_mykad,
          mobile: this.pre_mobile,
          address: this.pre_address,
          postcode: this.pre_postcode,
          city: this.pre_city,
          state: this.pre_state,
          email: this.pre_email,
          companyAddress: this.pre_company_address,
          companyPostcode: this.pre_company_postcode,
          companyCity: this.pre_company_city,
          companyState: this.pre_company_state,
          companyMobile: this.pre_company_mobile,
          amount: this.digitalidPrice,
          orderNo: this.data.content.order,
          uploadMyKadFront: '',
          uploadMyKadBack: '',
          uploadPayslip: ''
        }; 
        
        this.applicant_data = {
          id: 1,
          name: 'createDigitalId',
          content: createdid
        };
        //end   
    
        this.apiService.postData(this.applicant_data).subscribe((res) => {
            this.navCtrl.navigateForward('/members/success/' + this.data.content.order);
        });
      });
    });
  }
  else 
  {
    this.verify = false;
    //this.openDialog('Your balance is unsuffient. Please reload');
    this.spinner.hide();
  }
  

}
  

  firstname() {
    if (this.pre_firstname == null || this.pre_firstname == undefined) {
      this.is_firstname = false;
    } else if (this.pre_firstname.length == 0) {
      this.is_firstname = false;
    } else if (this.pre_firstname.length == "") {
      this.is_firstname = false;
    /*} else if (this.pre_firstname.toString().length > 40) {
      //this.openDialog('Maximum length of Last Name is 40 characters only');
      this.is_firstname = false;
    } else if (this.pre_firstname.toString().length < 5) {
      //this.openDialog('Minimum length of Last Name must be 5 characters');
      this.is_firstname = false;*/
    } else {
      this.is_firstname = true;
    }

    console.log("name = " + this.pre_firstname);
    console.log("is_firstname = " + this.is_firstname);

    this.checkAll();
  }

  lastname() {
    if (this.pre_lastname == null || this.pre_lastname == undefined) {
      this.is_lastname = false;
    } else if (this.pre_lastname.length == 0) {
      this.is_lastname = false;
    } else if (this.pre_lastname.length == "") {
      this.is_lastname = false;
   /* } else if (this.pre_lastname.toString().length > 40) {
      this.openDialog('Maximum length of Last Name is 40 characters only');
      this.is_lastname = false;
    } else if (this.pre_firstname.toString().length < 5) {
      this.openDialog('Minimum length of Last Name must be 5 characters');
      this.is_lastname = false;*/
    } else {
      this.is_lastname = true;
    }

    console.log("name = " + this.pre_lastname);
    console.log("is_lastname = " + this.is_lastname);

    this.checkAll();
  }

   mykad() 
   {
     if (this.pre_mykad == null || this.pre_mykad == undefined) 
     {
       //this.openDialog('equals to empty');
   
       this.is_mykad = false;
     }
     else if (this.pre_mykad.toString().length >= 12) 
     {
       //this.openDialog('equals to 12 according to array');
   
       this.is_mykad = true;
     } 
     else if (this.pre_mykad.toString().length != 12 || this.pre_mykad.toString().length < 12) 
     {
       //this.openDialog('equals to not 12 or less than 12');
   
       this.is_mykad = false;
     } 
     else 
     {
       this.is_mykad = true;
     }
     console.log("mykad = " + this.pre_mykad);
     console.log("is_mykad = " + this.is_mykad);
     this.checkAll();
   
     //this.openDialog("length = " + this.pre_mykad_passport.toString().length);
   }

   mobile() 
   {
     if (this.pre_mobile == null || this.pre_mobile == undefined) 
     {
       this.is_mobile = false;
     } 
     else if (this.pre_mobile.length == 0) 
     {
       this.is_mobile = false;
     } 
     else if (this.pre_mobile.length == "") 
     {
       this.is_mobile = false;
     } 
     /*else if (this.pre_mobile.toString().length >= 12) {
       this.openDialog('Maximum length of Mobile No is 11 digits only');
       this.is_mobile = false;
     } 
     else if (this.pre_mobile.toString().length <= 9) {
       this.openDialog('Minimum length of Mobile No must be more or equals to 10 digits');
       this.is_mobile = false;
     }*/
     else 
     {
       this.is_mobile = true;
     }
   
     console.log("mobile = " + this.pre_mobile);
     console.log("is_mobile = " + this.is_mobile);
   
     this.checkAll();
   }
 
   address() {
    if (this.pre_address == null || this.pre_address == undefined) {
      this.is_address = false;
    } else if (this.pre_address.length == 0) {
      this.is_address = false;
    } else if (this.pre_address.length == "") {
      this.is_address = false;
   /* } else if (this.pre_address.toString().length > 40) {
      this.openDialog('Maximum length of Permanent Address is 40 characters only');
      this.is_address = false;
    } else if (this.pre_address.toString().length < 5) {
      this.openDialog('Minimum length of Permanent Address must be 5 characters');
      this.is_address = false;  */     
    } else {
      this.is_address = true;
    }

    console.log("address = " + this.pre_address);
    console.log("is_address = " + this.is_address);

    this.checkAll();
  }

  postcode() 
   {
     if (this.pre_postcode == null || this.pre_postcode == undefined) 
     {
       //this.openDialog('equals to empty');
   
       this.is_postcode = false;
     }
     else if ((this.pre_postcode.toString().length == 4) || (this.pre_postcode.toString().length == 5))
     {
       this.is_postcode = true;
     } 
     else if ((this.pre_postcode.toString().length != 5 || this.pre_postcode.toString().length < 5) )
     {
       this.is_postcode = false;
     } 
     else if ((this.pre_postcode.toString().length != 4 || this.pre_postcode.toString().length < 5) )
     {
       this.is_postcode = false;
     } 
     else 
     {
       this.is_postcode = true;
     }
     console.log("postcode = " + this.pre_postcode);
     console.log("is_postcode = " + this.is_postcode);
     this.checkAll();
   }
  
 
   city() {
     if (this.pre_city == null || this.pre_city == undefined) {
       this.is_city = false;
     } else if (this.pre_city.length == 0) {
       this.is_city = false;
     } else if (this.pre_city.length == "") {
       this.is_city = false;
     } else {
       this.is_city = true;
     }
 
     console.log("city = " + this.pre_city);
     console.log("is_city = " + this.is_city);
 
     this.checkAll();
   }
 
   state() {
     if (this.pre_state == null || this.pre_state == undefined) {
       this.is_state = false;
     } else if (this.pre_state.length == 0) {
       this.is_state = false;
     } else if (this.pre_state.length == "") {
       this.is_state = false;
     } else {
       this.is_state = true;
     }
 
     console.log("state = " + this.pre_state);
     console.log("is_state = " + this.is_state);
 
     this.checkAll();
   }

   email() 
   {
     if (this.pre_email == null || this.pre_email == undefined) {
       this.is_email = false;
     } else if (this.pre_email.length == 0) {
       this.is_email = false;
     } else if (this.pre_email.length == "") {
       this.is_email = false;
     /*} else if (this.pre_email.toString().length > 40) {
       this.openDialog('Maximum length of Email No is 40 only');
       this.is_email = false;
     } else if (this.pre_email.toString().length < 5) {
       this.openDialog('Minimum length of Email No must be 5');
       this.is_email = false;*/
     }
     else 
     {
         var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         if (re.test(this.pre_email.toLowerCase())) this.is_email = true;
         else {
           this.is_email = false;
           this.pre_email = '';
           this.msg_email = 'Email format is not valid';
         }
   
     }
     console.log("email = " + this.pre_email);
     console.log("is_email = " + this.is_email);
 
     this.checkAll();
   }

   //sect2
   company_address() {
    if (this.pre_company_address == null || this.pre_company_address == undefined) {
      this.is_company_address = false;
    } else if (this.pre_company_address.length == 0) {
      this.is_company_address = false;
    } else if (this.pre_company_address.length == "") {
      this.is_company_address = false;
   /* } else if (this.pre_company_address.toString().length > 40) {
      this.openDialog('Maximum length of Company Address is 40 characters only');
      this.is_company_address = false;
    } else if (this.pre_address.toString().length < 5) {
      this.openDialog('Minimum length of Company Address must be 5 characters');
      this.is_company_address = false;  */     
    } else {
      this.is_company_address = true;
    }

    console.log("company address = " + this.pre_company_address);
    console.log("is_company_address = " + this.is_company_address);

    this.checkAll();
  }

  company_postcode() 
   {
     if (this.pre_company_postcode == null || this.pre_company_postcode == undefined) 
     {
       //this.openDialog('equals to empty');
   
       this.is_company_postcode = false;
     }
     else if ((this.pre_company_postcode.toString().length == 4) || (this.pre_company_postcode.toString().length == 5))
     {
       this.is_company_postcode = true;
     } 
     else if ((this.pre_company_postcode.toString().length != 5 || this.pre_company_postcode.toString().length < 5) )
     {
       this.is_company_postcode = false;
     } 
     else if ((this.pre_company_postcode.toString().length != 4 || this.pre_company_postcode.toString().length < 5) )
     {
       this.is_company_postcode = false;
     } 
     else 
     {
       this.is_company_postcode = true;
     }
     console.log("company postcode = " + this.pre_company_postcode);
     console.log("is_company_postcode = " + this.is_company_postcode);
     this.checkAll();
   }
  
 
   company_city() {
     if (this.pre_company_city == null || this.pre_company_city == undefined) {
       this.is_company_city = false;
     } else if (this.pre_company_city.length == 0) {
       this.is_company_city = false;
     } else if (this.pre_company_city.length == "") {
       this.is_company_city = false;
     } else {
       this.is_company_city = true;
     }
 
     console.log("company_city = " + this.pre_company_city);
     console.log("is_company_city = " + this.is_company_city);
 
     this.checkAll();
   }
 
   company_state() {
     if (this.pre_company_state == null || this.pre_company_state == undefined) {
       this.is_company_state = false;
     } else if (this.pre_company_state.length == 0) {
       this.is_company_state = false;
     } else if (this.pre_company_state.length == "") {
       this.is_company_state = false;
     } else {
       this.is_company_state = true;
     }
 
     console.log("company state = " + this.pre_company_state);
     console.log("is_company_state = " + this.is_company_state);
 
     this.checkAll();
   }


   company_mobile() 
   {
     if (this.pre_company_mobile == null || this.pre_company_mobile == undefined) 
     {
       this.is_company_mobile = false;
     } 
     else if (this.pre_company_mobile.length == 0) 
     {
       this.is_company_mobile = false;
     } 
     else if (this.pre_company_mobile.length == "") 
     {
       this.is_company_mobile = false;
     } 
     /*else if (this.pre_company_mobile.toString().length >= 12) {
       this.openDialog('Maximum length of Company Mobile No is 11 digits only');
       this.is_company_mobile = false;
     } 
     else if (this.pre_company_mobile.toString().length <= 9) {
       this.openDialog('Minimum length of Company Mobile No must be more or equals to 10 digits');
       this.is_company_mobile = false;
     }*/
     else 
     {
       this.is_company_mobile = true;
     }
   
     console.log("company mobile = " + this.pre_company_mobile);
     console.log("is_company_mobile = " + this.is_company_mobile);
   
     this.checkAll();
   }
 

  //submit all
  checkAll()
  {
    //sec1
    if (this.is_firstname == true &&
        this.is_lastname == true &&
        this.is_mykad == true &&
        this.is_mobile == true &&
        this.is_address == true &&
        this.is_postcode == true &&
        this.is_city == true &&
        this.is_state == true &&
        this.is_email == true)
    {
      console.log("all true");
      this.isCompleted = true;
    } 
    else 
    {
        console.log("all false");
        this.isCompleted = false;
    }
    //end sec1

    //sec2
    if (this.is_company_address == true &&
    this.is_company_postcode == true &&
    this.is_company_city == true &&
    this.is_company_state == true &&
    this.is_company_mobile == true)
    {
      console.log(" isCompleted2 all true");
      this.isCompleted2 = true;
    } 
    else 
    {
      console.log(" isCompleted2 all false");
      this.isCompleted2 = false;
    }

    //sec3
   if (
        (this.is_upload_mykad_front == true || this.is_upload_mykad_front == false) ||
        (this.is_upload_mykad_back == true || this.is_upload_mykad_back == false) ||
        (this.is_upload_payslip == true || this.is_upload_payslip == false)
      )
    {
      console.log(" isCompleted3 all true");
      this.isCompleted3 = true;
    }
    else 
    {
      console.log(" isCompleted3 all false");
      this.isCompleted3 = false;
    }


    console.log(this.isCompleted);
    console.log(this.isCompleted2);
    console.log(this.isCompleted3);
  }


  ngOnDestroy() 
  {
  }

  logout() {
    this.authService.logout();
  }


}


@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogApplyDigitalidPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

}